function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// @ts-nocheck
import React from 'react'; // import * as types from '../../type'

import Icon from "../../../Icon";
import { ADDITIONAL_PROPERTY_FLAG, isMultiSelect, isSelect, retrieveSchema, toIdSchema, getDefaultRegistry, mergeObjects, getUiOptions, isFilesArray, deepEquals, getSchemaType } from "../../utils";
const REQUIRED_FIELD_SYMBOL = '*';
const COMPONENT_TYPES = {
  array: 'ArrayField',
  boolean: 'BooleanField',
  integer: 'NumberField',
  number: 'NumberField',
  object: 'ObjectField',
  string: 'StringField',
  null: 'NullField'
};

function getFieldComponent(schema, uiSchema, idSchema, fields) {
  var _schema$anyOf;

  const field = uiSchema['ui:field'];

  if (typeof field === 'function') {
    return field;
  }

  if (typeof field === 'string' && field in fields) {
    return fields[field];
  }

  const componentName = COMPONENT_TYPES[getSchemaType(schema)]; // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't
  // render a field and let the MultiSchemaField component handle the form display

  if (!componentName && ((_schema$anyOf = schema.anyOf) !== null && _schema$anyOf !== void 0 ? _schema$anyOf : schema.oneOf)) {
    return () => null;
  }

  return componentName in fields ? fields[componentName] : () => {
    const {
      UnsupportedField
    } = fields;
    return /*#__PURE__*/React.createElement(UnsupportedField, {
      schema: schema,
      idSchema: idSchema,
      reason: `Unknown field type ${schema.type}`
    });
  };
}

function Label(props) {
  const {
    label,
    required,
    id
  } = props;

  if (!label) {
    return null;
  }

  return /*#__PURE__*/React.createElement("label", {
    // className="control-label"
    htmlFor: id
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: "required"
  }, REQUIRED_FIELD_SYMBOL));
}

function LabelInput(props) {
  const {
    id,
    label,
    onChange
  } = props;
  return /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    type: "text",
    id: id,
    onBlur: event => onChange(event.target.value),
    defaultValue: label
  });
}

function Help(props) {
  const {
    help
  } = props;

  if (!help) {
    return null;
  }

  if (typeof help === 'string') {
    return /*#__PURE__*/React.createElement("p", {
      className: "help-block"
    }, help);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "help-block"
  }, help);
}

function ErrorList(props) {
  const {
    errors = []
  } = props;

  if (errors.length === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
    className: "error-detail bs-callout bs-callout-info"
  }, errors.filter(elem => !!elem).map((error, index) => /*#__PURE__*/React.createElement("li", {
    className: "text-danger",
    key: index
  }, error))));
}

function DefaultTemplate(props) {
  const {
    id,
    label,
    children,
    errors,
    help,
    description,
    hidden,
    required,
    displayLabel
  } = props;

  if (hidden) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hidden"
    }, children);
  }

  return /*#__PURE__*/React.createElement(WrapIfAdditional, props, displayLabel && /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required,
    id: id
  }), displayLabel && description ? description : null, children, errors, help);
} // if (process.env.NODE_ENV !== 'production') {
//   DefaultTemplate.propTypes = {
//     id: PropTypes.string,
//     classNames: PropTypes.string,
//     label: PropTypes.string,
//     children: PropTypes.node.isRequired,
//     errors: PropTypes.element,
//     rawErrors: PropTypes.arrayOf(PropTypes.string),
//     help: PropTypes.element,
//     rawHelp: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
//     description: PropTypes.element,
//     rawDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
//     hidden: PropTypes.bool,
//     required: PropTypes.bool,
//     readonly: PropTypes.bool,
//     displayLabel: PropTypes.bool,
//     fields: PropTypes.object,
//     formContext: PropTypes.object,
//   }
// }


DefaultTemplate.defaultProps = {
  hidden: false,
  readonly: false,
  required: false,
  displayLabel: true
};

function WrapIfAdditional(props) {
  const {
    id,
    classNames,
    disabled,
    label,
    onKeyChange,
    onDropPropertyClick,
    readonly,
    required,
    schema
  } = props;
  const keyLabel = `${label} Key`; // i18n ?

  const additional = schema.hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);

  if (!additional) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames
    }, props.children);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-5 form-additional"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement(Label, {
    label: keyLabel,
    required: required,
    id: `${id}-key`
  }), /*#__PURE__*/React.createElement(LabelInput, {
    label: label,
    required: required,
    id: `${id}-key`,
    onChange: onKeyChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-additional form-group col-xs-5"
  }, props.children), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-2"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "delete",
    tabIndex: "-1",
    style: {
      border: '0'
    },
    disabled: disabled || readonly,
    onPress: onDropPropertyClick(label)
  }))));
}

function SchemaFieldRender(props) {
  var _ref, _uiSchema$uiFieldTem, _ref4, _uiSchema$uiDescript;

  const {
    uiSchema,
    formData,
    errorSchema,
    idPrefix,
    name,
    onKeyChange,
    onDropPropertyClick,
    required,
    registry = getDefaultRegistry(),
    wasPropertyKeyModified = false,
    noFieldTemplate = false
  } = props;
  const {
    rootSchema,
    fields,
    formContext
  } = registry;
  const FieldTemplate = (_ref = (_uiSchema$uiFieldTem = uiSchema['ui:FieldTemplate']) !== null && _uiSchema$uiFieldTem !== void 0 ? _uiSchema$uiFieldTem : registry.FieldTemplate) !== null && _ref !== void 0 ? _ref : DefaultTemplate;
  let {
    idSchema
  } = props;
  const schema = retrieveSchema(props.schema, rootSchema, formData);
  idSchema = mergeObjects(toIdSchema(schema, null, rootSchema, formData, idPrefix), idSchema);
  const FieldComponent = getFieldComponent(schema, uiSchema, idSchema, fields);
  const {
    DescriptionField
  } = fields;
  const disabled = Boolean(props.disabled || uiSchema['ui:disabled']);
  const readonly = Boolean(props.readonly || uiSchema['ui:readonly'] || props.schema.readOnly || schema.readOnly);
  const autofocus = Boolean(props.autofocus || uiSchema['ui:autofocus']);

  if (Object.keys(schema).length === 0) {
    return null;
  }

  const uiOptions = getUiOptions(uiSchema);
  let {
    label: displayLabel = true
  } = uiOptions;

  if (schema.type === 'array') {
    displayLabel = isMultiSelect(schema, rootSchema) || isFilesArray(schema, uiSchema, rootSchema);
  }

  if (schema.type === 'object') {
    displayLabel = false;
  }

  if (schema.type === 'boolean' && !uiSchema['ui:widget']) {
    displayLabel = false;
  }

  if (uiSchema['ui:field']) {
    displayLabel = false;
  }

  const {
    __errors
  } = errorSchema,
        fieldErrorSchema = _objectWithoutProperties(errorSchema, ["__errors"]); // See #439: uiSchema: Don't pass consumed class names to child components


  const field = /*#__PURE__*/React.createElement(FieldComponent, _extends({}, props, {
    idSchema: idSchema,
    schema: schema,
    uiSchema: _objectSpread(_objectSpread({}, uiSchema), {}, {
      classNames: undefined
    }),
    disabled: disabled,
    readonly: readonly,
    autofocus: autofocus,
    errorSchema: fieldErrorSchema,
    formContext: formContext,
    rawErrors: __errors
  }));
  const {
    type
  } = schema;
  const id = idSchema.$id; // If this schema has a title defined, but the user has set a new key/label, retain their input.

  let label;

  if (wasPropertyKeyModified) {
    label = name;
  } else {
    var _ref2, _ref3, _uiSchema$uiTitle;

    label = (_ref2 = (_ref3 = (_uiSchema$uiTitle = uiSchema['ui:title']) !== null && _uiSchema$uiTitle !== void 0 ? _uiSchema$uiTitle : props.schema.title) !== null && _ref3 !== void 0 ? _ref3 : schema.title) !== null && _ref2 !== void 0 ? _ref2 : name;
  }

  const description = (_ref4 = (_uiSchema$uiDescript = uiSchema['ui:description']) !== null && _uiSchema$uiDescript !== void 0 ? _uiSchema$uiDescript : props.schema.description) !== null && _ref4 !== void 0 ? _ref4 : schema.description;
  const errors = __errors;
  const help = uiSchema['ui:help'];
  const hidden = uiSchema['ui:widget'] === 'hidden';
  const classNames = ['form-group', 'field', `field-${type}`, errors && errors.length > 0 ? 'field-error has-error has-danger' : '', uiSchema.classNames].join(' ').trim();
  const fieldProps = {
    description: /*#__PURE__*/React.createElement(DescriptionField, {
      id: `${id}__description`,
      description: description,
      formContext: formContext
    }),
    rawDescription: description,
    help: /*#__PURE__*/React.createElement(Help, {
      help: help
    }),
    rawHelp: typeof help === 'string' ? help : undefined,
    errors: /*#__PURE__*/React.createElement(ErrorList, {
      errors: errors
    }),
    rawErrors: errors,
    id,
    label,
    hidden,
    onKeyChange,
    onDropPropertyClick,
    required,
    disabled,
    readonly,
    displayLabel,
    classNames,
    formContext,
    fields,
    schema,
    uiSchema
  };
  const _AnyOfField = registry.fields.AnyOfField;
  const _OneOfField = registry.fields.OneOfField;
  return noFieldTemplate ? /*#__PURE__*/React.createElement(React.Fragment, null, field, schema.anyOf && !isSelect(schema) && /*#__PURE__*/React.createElement(_AnyOfField, {
    disabled: disabled,
    errorSchema: errorSchema,
    formData: formData,
    idPrefix: idPrefix,
    idSchema: idSchema,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    options: schema.anyOf,
    baseType: schema.type,
    registry: registry,
    schema: schema,
    uiSchema: uiSchema
  }), schema.oneOf && !isSelect(schema) && /*#__PURE__*/React.createElement(_OneOfField, {
    disabled: disabled,
    errorSchema: errorSchema,
    formData: formData,
    idPrefix: idPrefix,
    idSchema: idSchema,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    options: schema.oneOf,
    baseType: schema.type,
    registry: registry,
    schema: schema,
    uiSchema: uiSchema
  })) : /*#__PURE__*/React.createElement(FieldTemplate, fieldProps, /*#__PURE__*/React.createElement(React.Fragment, null, field, schema.anyOf && !isSelect(schema) && /*#__PURE__*/React.createElement(_AnyOfField, {
    disabled: disabled,
    errorSchema: errorSchema,
    formData: formData,
    idPrefix: idPrefix,
    idSchema: idSchema,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    options: schema.anyOf,
    baseType: schema.type,
    registry: registry,
    schema: schema,
    uiSchema: uiSchema
  }), schema.oneOf && !isSelect(schema) && /*#__PURE__*/React.createElement(_OneOfField, {
    disabled: disabled,
    errorSchema: errorSchema,
    formData: formData,
    idPrefix: idPrefix,
    idSchema: idSchema,
    onBlur: props.onBlur,
    onChange: props.onChange,
    onFocus: props.onFocus,
    options: schema.oneOf,
    baseType: schema.type,
    registry: registry,
    schema: schema,
    uiSchema: uiSchema
  })));
}

class SchemaField extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return !deepEquals(this.props, nextProps);
  }

  render() {
    return SchemaFieldRender(this.props);
  }

}

SchemaField.defaultProps = {
  uiSchema: {},
  errorSchema: {},
  idSchema: {},
  disabled: false,
  readonly: false,
  autofocus: false
}; // if (process.env.NODE_ENV !== 'production') {
//   SchemaField.propTypes = {
//     schema: PropTypes.object.isRequired,
//     uiSchema: PropTypes.object,
//     idSchema: PropTypes.object,
//     formData: PropTypes.any,
//     errorSchema: PropTypes.object,
//     registry: types.registry.isRequired,
//   }
// }

export default SchemaField;